import { render, staticRenderFns } from "./MainModeBook.vue?vue&type=template&id=55a77d7c&scoped=true&"
import script from "@/scripts/MainMode/MainModeBook/index.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeBook/index.js?vue&type=script&lang=js&"
import style0 from "./MainModeBook.vue?vue&type=style&index=0&id=55a77d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a77d7c",
  null
  
)

export default component.exports